import { MouseEvent } from 'react';

import { ModalsProvider } from '@speeki/global-ui-components';

/**
 * Opens the contact-support pop-up from a link without following its href.
 * The provider only shows the first queued modal, so anything already open
 * (the mobile pop-ups carry their own footer with this link) is cleared first;
 * otherwise the support pop-up would stay hidden until that one closed.
 */
export const openContactSupport = (event?: MouseEvent<HTMLElement>) => {
    event?.preventDefault();
    // clear() also drops any modal queued behind the visible one: those are
    // hidden anyway and would pop up unannounced once this one closes, and a
    // prompt that still matters returns the next time it is triggered.
    ModalsProvider.clear();
    ModalsProvider.open('ContactSupportModal');
};
